import { render, staticRenderFns } from "./BarChartHorario.vue?vue&type=template&id=f34b8b04"
import script from "./BarChartHorario.vue?vue&type=script&lang=js"
export * from "./BarChartHorario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports